




























































































import Vue from 'vue';
import { ISenderDomain, IDunning } from '@/store/types';
import { SYNC_DUNNING } from '@/store/action-types';
import SenderDomainsConfig from '@/components/Settings/CustomDomains/SenderDomainsConfig.vue';
import CheckoutDomainsConfig from '@/components/Settings/CustomDomains/CheckoutDomainsConfig.vue';
import ShortListLoader from '@/components/UI/Loader/ShortListLoader.vue';
import ChecklistItem from '@/components/UI/ChecklistItem.vue';

export default Vue.extend({
  name: 'CustomDomainSettings',
  components: {
    CheckoutDomainsConfig,
    SenderDomainsConfig,
    ShortListLoader,
    ChecklistItem,
  },
  async created() {
    if (!this.$store.state.org || !this.$store.state.org?.dunning) {
      await this.$store.dispatch(SYNC_DUNNING);
    }
  },
  computed: {
    dunning(): IDunning {
      return this.$store.state.org?.dunning;
    },
    senderDomains(): ISenderDomain[] {
      if (!this.dunning) return [];
      return this.dunning.senderDomains || [];
    },
    verifiedSenderDomains(): ISenderDomain[] {
      return this.senderDomains.filter((domain) => domain?.returnPathVerified && domain?.dkimVerified);
    },
    isSenderDomainVerified(): boolean {
      return this.senderDomains.some((domain: ISenderDomain) => domain?.returnPathVerified && domain?.dkimVerified);
    },
    loading(): boolean {
      return !this.dunning;
    },
  },
  methods: {
    async reloadData() {
      await this.$store.dispatch(SYNC_DUNNING);
    },
  },
});
